var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _image;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h200v200H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 22h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m14 4h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m18 4h4v-2a2 2 0 0 0-4 0m8 2h4v-4h-2a2 2 0 0 0-2 2m4-2v4h4v-2a2 2 0 0 0-2-2m6 4h4v-4h-2a2 2 0 0 0-2 2m4-2v4h4v-2a2 2 0 0 0-2-2m14 4v-4h-2a2 2 0 0 0 0 4m2-4v4h2a2 2 0 0 0 0-4m-94 4h-4v2a2 2 0 0 0 4 0m8 2h4v-2a2 2 0 0 0-4 0m8 2h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 24,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 24,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 22h4v4h-4zm8 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m-70 4h-4v2a2 2 0 0 0 4 0m4-2h4v4h-4zm4 0h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 28,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 30v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm16 4v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 28,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 34h4v-4h-2a2 2 0 0 0-2 2m4-2v4h4v-2a2 2 0 0 0-2-2m14 4v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4zm8 4h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m14 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m10 0h-4v2a2 2 0 0 0 4 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 32,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 34h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m14 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm12 4v-4h-2a2 2 0 0 0 0 4m2-4v4h2a2 2 0 0 0 0-4m6 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m-82 4h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m8 2h4v-2a2 2 0 0 0-4 0m8-2h4v4h-4zm8 0h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m16 2v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 40,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 42h-4v2a2 2 0 0 0 4 0m4 2h4v-2a2 2 0 0 0-4 0m8-2h4v4h-4zm8 0h4v4h-4zm12 0h-4v2a2 2 0 0 0 4 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 44,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 44,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 42h4v4h-4zm12 0h-4v2a2 2 0 0 0 4 0m4-2h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 44,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 46h4v-2a2 2 0 0 0-4 0m8 2h4v-2a2 2 0 0 0-4 0m-88 6v-4h-2a2 2 0 0 0 0 4m6-4h-4v4h2a2 2 0 0 0 2-2m8-2h-4v2a2 2 0 0 0 4 0m8 2v-4h-4v2a2 2 0 0 0 2 2m2-4v4h2a2 2 0 0 0 0-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 48,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 46h4v4h-4zm20 0h-4v2a2 2 0 0 0 4 0m12 2v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2M30 54h4v-2a2 2 0 0 0-4 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 52,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 52,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 54h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm24 4v-4h-2a2 2 0 0 0 0 4m2-4v4h4v-2a2 2 0 0 0-2-2m14 0h-4v2a2 2 0 0 0 4 0m16 2v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m10 4v-4h-2a2 2 0 0 0 0 4m2-4v4h4v-2a2 2 0 0 0-2-2M18 58h4v-2a2 2 0 0 0-4 0m16 2v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 56,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 56,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 58v-4h-2a2 2 0 0 0 0 4m2-4v4h2a2 2 0 0 0 0-4m14 4v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m14 0h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 56,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 58v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m10 0h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m10 0h-4v2a2 2 0 0 0 4 0M18 58h4v4h-4zm20 4v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m14 4h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 60,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 62h4v-2a2 2 0 0 0-4 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 60,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 58h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 60,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 62h4v-2a2 2 0 0 0-4 0m12 2v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zM22 62h-4v2a2 2 0 0 0 4 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 64,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 62h-4v2a2 2 0 0 0 4 0m4 2h4v-2a2 2 0 0 0-4 0m12-2h4v4h-4zm12 4h4v-2a2 2 0 0 0-4 0m8 2h4v-4h-2a2 2 0 0 0-2 2m4-2v4h4v-2a2 2 0 0 0-2-2m6 0h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 64,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 62h-4v2a2 2 0 0 0 4 0m4 2h4v-2a2 2 0 0 0-4 0m16 2v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m10 0h-4v2a2 2 0 0 0 4 0M46 70v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm12 4v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm8 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m20 2v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m14 4h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m6 0h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m4 2h4v-2a2 2 0 0 0-4 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 68,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 74h4v-4h-2a2 2 0 0 0-2 2m4-2v4h2a2 2 0 0 0 0-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 72,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 70h4v4h-4zm16 4v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm4 0h4v4h-4zm28 4v-4h-2a2 2 0 0 0 0 4m2-4v4h4v-2a2 2 0 0 0-2-2m10 0h4v4h-4zm12 4v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4zm16 4v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm4 0h4v4h-4zm16 0h-4v2a2 2 0 0 0 4 0M22 74h-4v2a2 2 0 0 0 4 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 76,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 74h4v4h-4zm24 4v-4h-4v2a2 2 0 0 0 2 2m2-4v4h4v-2a2 2 0 0 0-2-2m14 4h4v-2a2 2 0 0 0-4 0m8-2h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm16 0h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 76,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 74h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m14 4h4v-2a2 2 0 0 0-4 0M22 82h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m14 4h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m8 2h4v-2a2 2 0 0 0-4 0m12-2h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 80,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 78h-4v2a2 2 0 0 0 4 0m4-2h4v4h-4zm16 4v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m6 0h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 80,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 82v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm20 0h4v4h-4zM22 82h4v4h-4zm16 4h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm8 4h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m6 0h4v4h-4zm24 0h4v4h-4zm28 4v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m18 0h4v4h-4zm20 4v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zM18 90h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m10 4v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm16 4v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm4 0h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m8-2h-4v2a2 2 0 0 0 4 0m8-2h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m10 4h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm12 4h4v-4h-2a2 2 0 0 0-2 2m4-2v4h2a2 2 0 0 0 0-4m10 0h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 88,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 90h4v-4h-2a2 2 0 0 0-2 2m8-2h-4v4h2a2 2 0 0 0 2-2m16-2h4v4h-4zM22 94v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm4 0h4v4h-4zm12 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m10 0h4v4h-4zm4 0h4v4h-4zm20 4h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m8 2v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm12 4h4v-4h-2a2 2 0 0 0-2 2m8-2h-4v4h2a2 2 0 0 0 2-2m16-2h4v4h-4zm12 4v-4h-2a2 2 0 0 0 0 4m2-4v4h4v-2a2 2 0 0 0-2-2m10 4v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zM26 98v-4h-4v2a2 2 0 0 0 2 2m6-4h-4v4h2a2 2 0 0 0 2-2m8 2v-4h-2a2 2 0 0 0 0 4m6-4h-4v4h2a2 2 0 0 0 2-2m4 2h4v-2a2 2 0 0 0-4 0m12 2v-4h-4v2a2 2 0 0 0 2 2m6-4h-4v4h2a2 2 0 0 0 2-2m16-2h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 96,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 94h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm20 4v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m6 0h4v4h-4zm12 0h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 100,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 102h4v-2a2 2 0 0 0-4 0m16 2v-4h-2a2 2 0 0 0 0 4m6-4h-4v4h2a2 2 0 0 0 2-2m12 2h4v-4h-2a2 2 0 0 0-2 2m4-2v4h4v-2a2 2 0 0 0-2-2m14 4v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 100,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 98h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m4-2h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 100,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 98h4v4h-4zm16 4v-4h-4v2a2 2 0 0 0 2 2m2-4v4h2a2 2 0 0 0 0-4m6 0h4v4h-4zm-156 8h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m18 4h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm8 4h4v-2a2 2 0 0 0-4 0m16-2h-4v2a2 2 0 0 0 4 0m8-2h4v4h-4zm16 4v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m8-2h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m12 2v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m14 4h4v-4h-2a2 2 0 0 0-2 2m8-2h-4v4h2a2 2 0 0 0 2-2m-156 2h-4v2a2 2 0 0 0 4 0m8-2h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 108,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 106h4v4h-4zm4 0h4v4h-4zm12 0h-4v2a2 2 0 0 0 4 0m4-2h4v4h-4zm8 4h4v-2a2 2 0 0 0-4 0m12 2v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m14 4h4v-2a2 2 0 0 0-4 0m8-2h4v4h-4zm12 4v-4h-2a2 2 0 0 0 0 4m2-4v4h2a2 2 0 0 0 0-4m6 0h4v4h-4zm4 0h4v4h-4zm12 4v-4h-2a2 2 0 0 0 0 4m2-4v4h4v-2a2 2 0 0 0-2-2m10 0h-4v2a2 2 0 0 0 4 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 112,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 114h4v-2a2 2 0 0 0-4 0m8-2h4v4h-4zm16 4h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m14 0h-4v2a2 2 0 0 0 4 0m8 2v-4h-4v2a2 2 0 0 0 2 2m2-4v4h2a2 2 0 0 0 0-4m22 4v-4h-4v2a2 2 0 0 0 2 2m2-4v4h2a2 2 0 0 0 0-4m10 0h4v4h-4zm4 0h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m12 2h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m6 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m-146 4h4v4h-4zm12 0h-4v2a2 2 0 0 0 4 0m8 2v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 116,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 118h4v-2a2 2 0 0 0-4 0m12 2v-4h-2a2 2 0 0 0 0 4m2-4v4h4v-2a2 2 0 0 0-2-2m14 4h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 116,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 118v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m8-2h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 116,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 122h4v-2a2 2 0 0 0-4 0m8-2h4v4h-4zm24 0h-4v2a2 2 0 0 0 4 0m8 2v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m10 4v-4h-2a2 2 0 0 0 0 4m2-4v4h4v-2a2 2 0 0 0-2-2m10 4v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m6 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 120,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 118h4v4h-4zm20 0h-4v2a2 2 0 0 0 4 0m-152 2h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 124,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 122h-4v2a2 2 0 0 0 4 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 124,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 122h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m10 4v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m8-2h-4v2a2 2 0 0 0 4 0m4-2h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m4 2h4v-2a2 2 0 0 0-4 0m16 2h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm8 4h4v-4h-2a2 2 0 0 0-2 2m4-2v4h4v-2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 124,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 126h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 128,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 130v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m6 0h4v4h-4zm4 0h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m20-2h-4v2a2 2 0 0 0 4 0m12 2v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m10 4v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m8 2h4v-2a2 2 0 0 0-4 0m-152 6v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m12 2v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 132,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 132,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 134h4v-4h-2a2 2 0 0 0-2 2m8-2h-4v4h2a2 2 0 0 0 2-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 132,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 134h4v-2a2 2 0 0 0-4 0m12-2h-4v2a2 2 0 0 0 4 0m12-2h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm16 0h4v4h-4zm-140 8v-4h-2a2 2 0 0 0 0 4m2-4v4h2a2 2 0 0 0 0-4m34 4h4v-4h-2a2 2 0 0 0-2 2m4-2v4h2a2 2 0 0 0 0-4m10 0h4v4h-4zm8 4h4v-4h-2a2 2 0 0 0-2 2m4-2v4h4v-2a2 2 0 0 0-2-2m10 4h4v-2a2 2 0 0 0-4 0m12 2v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m6 4h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m4-2h4v4h-4zm8 4h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 140,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 140,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 142v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m10 4v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m12-2h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m6 0h4v4h-4zm12 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm20 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm12 0h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 144,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 146v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m10 0h-4v2a2 2 0 0 0 4 0m8 2h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm12 4v-4h-4v2a2 2 0 0 0 2 2m6-4h-4v4h2a2 2 0 0 0 2-2m8 2v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m10 0h-4v2a2 2 0 0 0 4 0m12 2v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm12 4h4v-2a2 2 0 0 0-4 0m8-2h4v4h-4zm12 0h-4v2a2 2 0 0 0 4 0m4 2h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 148,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 148,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 150v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m30 4v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm16 4v-4h-4v2a2 2 0 0 0 2 2m2-4v4h2a2 2 0 0 0 0-4m26 4v-4h-4v2a2 2 0 0 0 2 2m2-4v4h4v-2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 148,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 146h4v4h-4zm8 4h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m10 4v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 152,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 154h4v-2a2 2 0 0 0-4 0m8 2h4v-2a2 2 0 0 0-4 0m8-2h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 152,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 154v-4h-4v2a2 2 0 0 0 2 2m2-4v4h2a2 2 0 0 0 0-4m14 4v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm8 0h4v4h-4zm16 0h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m6 0h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m-128 6h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 156,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 156,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 154h4v4h-4zm8 0h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 156,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 154h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm-120 4h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m4-2h4v4h-4zm16 4h4v-2a2 2 0 0 0-4 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 160,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 158h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm16 0h4v4h-4zm12 4v-4h-4v2a2 2 0 0 0 2 2m6-4h-4v4h2a2 2 0 0 0 2-2m-120 2h-4v2a2 2 0 0 0 4 0m20 2v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm4 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m6 0h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 164,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 164,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 162h4v4h-4zm12 4v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 168,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 170h4v-2a2 2 0 0 0-4 0m8 2h4v-4h-2a2 2 0 0 0-2 2m4-2v4h4v-2a2 2 0 0 0-2-2m10 4v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm12 4v-4h-2a2 2 0 0 0 0 4m2-4h4v4h-4zm8 4h4v-2a2 2 0 0 0-4 0m12 2v-4h-2a2 2 0 0 0 0 4m2-4v4h4v-2a2 2 0 0 0-2-2m22 0h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m10 4v-4h-4v2a2 2 0 0 0 2 2m6-4h-4v4h2a2 2 0 0 0 2-2m4-2h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m-114 8h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm12 0h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m6 0h4v4h-4zm8 0h4v4h-4zm16 0h-4v2a2 2 0 0 0 4 0m4 2h4v-2a2 2 0 0 0-4 0m12 2h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm24 0h-4v2a2 2 0 0 0 4 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 172,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 172,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 174h4v4h-4zm20 4v-4h-4v2a2 2 0 0 0 2 2m2-4v4h4v-2a2 2 0 0 0-2-2m6 0h4v4h-4zm8 4h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm8 4h4v-2a2 2 0 0 0-4 0m16-2h-4v2a2 2 0 0 0 4 0m8-2h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m6 4h4v-4h-2a2 2 0 0 0-2 2m4-2v4h4v-2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 176,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 178h4v-2a2 2 0 0 0-4 0m-116 6v-4h-4v2a2 2 0 0 0 2 2m2-4v4h2a2 2 0 0 0 0-4m18 0h-4v2a2 2 0 0 0 4 0m8 2v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2m12-2h-4v2a2 2 0 0 0 4 0m8 2v-4h-4v2a2 2 0 0 0 2 2m2-4v4h2a2 2 0 0 0 0-4m22 4v-4h-4v2a2 2 0 0 0 2 2m6-4h-4v4h2a2 2 0 0 0 2-2m8-2h-4v2a2 2 0 0 0 4 0m8 2v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm4 0v4h2a2 2 0 0 0 0-4m14 0h-4v2a2 2 0 0 0 4 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 28v8a10 10 0 0 0 10 10h8a10 10 0 0 0 10-10v-8a10 10 0 0 0-10-10h-8a10 10 0 0 0-10 10m10-6h8a6 6 0 0 1 6 6v8a6 6 0 0 1-6 6h-8a6 6 0 0 1-6-6v-8a6 6 0 0 1 6-6",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 30h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m-10 4h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm-4 8v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172 18h-8a10 10 0 0 0-10 10v8a10 10 0 0 0 10 10h8a10 10 0 0 0 10-10v-8a10 10 0 0 0-10-10m6 10v8a6 6 0 0 1-6 6h-8a6 6 0 0 1-6-6v-8a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162 30h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m-10 4h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm-4 8v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 182h8a10 10 0 0 0 10-10v-8a10 10 0 0 0-10-10h-8a10 10 0 0 0-10 10v8a10 10 0 0 0 10 10m-6-10v-8a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v8a6 6 0 0 1-6 6h-8a6 6 0 0 1-6-6",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 166h4v-4h-2a2 2 0 0 0-2 2m4-2h4v4h-4zm4 0v4h4v-2a2 2 0 0 0-2-2m-10 4h4v4h-4zm4 0h4v4h-4zm4 0h4v4h-4zm-4 8v-4h-4v2a2 2 0 0 0 2 2m2-4h4v4h-4zm8 0h-4v4h2a2 2 0 0 0 2-2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h200v200H0z",
    clipPath: "url('#a')"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M0 0h200v200H0z",
    clipPath: "url('#b')"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M18 18h28v28H18z",
    clipPath: "url('#c')"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M26 26h12v12H26z",
    clipPath: "url('#d')"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M154 18h28v28h-28z",
    clipPath: "url('#e')"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M162 26h12v12h-12z",
    clipPath: "url('#f')"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M18 154h28v28H18z",
    clipPath: "url('#g')"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M26 162h12v12H26z",
    clipPath: "url('#h')"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 68,
    height: 68,
    x: 66,
    y: 66,
    href: "data:image/svg+xml;base64,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"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappQr);
export default __webpack_public_path__ + "static/media/whatsapp-qr.f4a687e7172399fa5751ade4034ac601.svg";
export { ForwardRef as ReactComponent };